import React from "react"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
} from "react-share"

import Config from "Data"

const iconSize = 28

const Share = ({ post }) => (
  <>
    <div className="share">
      <span className="label">Share</span>
      <div className="links">
        <TwitterShareButton
          url={`${Config.siteUrl}${post.name}`}
          title={post.title}
          via={`${Config.social.twitter}`}
          hashtags={[`${post.title}`]}>
          <TwitterIcon round size={iconSize} />
        </TwitterShareButton>
        <FacebookShareButton url={`${Config.siteUrl}/${post.name}`} quote={`${post.title} - ${post.subtitle}`}>
          <FacebookIcon round size={iconSize} />
        </FacebookShareButton>
        <LinkedinShareButton url={`${post.name}`} title={post.title} description={post.subtitle}>
          <LinkedinIcon round size={iconSize} />
        </LinkedinShareButton>
        <WhatsappShareButton url={`${Config.siteUrl}${post.name}`} title={`${post.title} - ${post.subtitle}`}>
          <WhatsappIcon round size={iconSize} />
        </WhatsappShareButton>
        <EmailShareButton url={`${post.name}`} subject={`Check this out - ${post.title}`} body={post.subtitle}>
          <EmailIcon round size={iconSize} />
        </EmailShareButton>
      </div>
    </div>
  </>
)

export default Share
